import React from "react";
import { Link } from "react-router-dom";
import { createFavoriteAlert, removeFavoriteAlert } from "../../../api";

class AlertCardItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      post: this.props.post,
    };
  }

  setAsFavourite = () => {
    createFavoriteAlert(this.state.post.id);
    let p = this.state.post;
    p.isFavourite = !this.state.post.isFavourite;
    this.setState({
      post: p,
    });
  };

  removeAsFavorite = () => {
    removeFavoriteAlert(this.state.post.id);
    let p = this.state.post;
    p.isFavourite = !this.state.post.isFavourite;
    this.setState({
      post: p,
    });
  };

  render() {
    return (
      <div className="favorite-item">
        <div class="rating" style={{ paddingRight: "8px", marginTop: "4px" }}>
          {this.state.post.isFavourite ? (
            <span className="selected" onClick={this.removeAsFavorite}>
              ★
            </span>
          ) : (
            <span onClick={this.setAsFavourite}>☆</span>
          )}
        </div>
        <div className="notif-content">
          <p className="notif-text">
            <Link to={`/alerts/${this.state.post.id}`} className={"black"}>
              {this.state.post.content && (
                <div
                  dangerouslySetInnerHTML={{ __html: this.state.post.content }}
                ></div>
              )}
            </Link>
          </p>
          <div className="date-block">
            <span className="date">{this.state.post.createdAt}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default AlertCardItem;
